import React from "react";

export default ({ width = 12, height = 12, fill = "#6D7F92", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 22 26"
      fill="none"
    >
      <path
        d="M6.29898 8.88634V7.20907C6.31168 4.71305 8.40746 2.67424 10.9986 2.67424C12.9801 2.67424 14.7583 3.90423 15.4061 5.74426C15.622 6.31577 16.2571 6.61271 16.8287 6.41517C17.1082 6.32696 17.3368 6.12817 17.4638 5.86726C17.5908 5.60635 17.6162 5.30817 17.5146 5.03484C16.5493 2.3276 13.9327 0.5 10.9732 0.5C7.1881 0.5 4.10158 3.52033 4.07617 7.23392V9.13855L6.29898 8.88634Z"
        fill="#DE4848"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.711 8.88867H16.289C19.2358 8.88867 21.625 11.2257 21.625 14.1081V20.2804C21.625 23.1628 19.2358 25.4998 16.289 25.4998H5.711C2.7642 25.4998 0.375 23.1628 0.375 20.2804V14.1081C0.375 11.2257 2.7642 8.88867 5.711 8.88867ZM10.9936 19.6605C11.616 19.6605 12.1114 19.1759 12.1114 18.5671V15.809C12.1114 15.2126 11.616 14.7281 10.9936 14.7281C10.384 14.7281 9.8886 15.2126 9.8886 15.809V18.5671C9.8886 19.1759 10.384 19.6605 10.9936 19.6605Z"
        fill="#DE4848"
      />
    </svg>
  );
};
